import { Reducer } from 'redux'
import { otpActionTypes, OtpRouteContext } from './actions'

export type OtpState = {
  routeContext: OtpRouteContext | null
  isRequestingOtp: boolean
  isResendingOtp: boolean
  errorMessage: string
}

export const initialState: OtpState = {
  routeContext: null,
  isRequestingOtp: false,
  isResendingOtp: false,
  errorMessage: '',
}

type actionType = {
  type: otpActionTypes
  payload?: unknown
}

export const reducer: Reducer<OtpState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case otpActionTypes.SET_OTP_ROUTE_CONTEXT:
      return {
        ...state,
        routeContext: action.payload as OtpRouteContext,
      }
    case otpActionTypes.REQUEST_OTP_START:
      return {
        ...state,
        isRequestingOtp: true,
        errorMessage: '',
      }
    case otpActionTypes.REQUEST_OTP_SUCCESS:
      return {
        ...state,
        isRequestingOtp: false,
      }
    case otpActionTypes.REQUEST_OTP_ERROR:
      return {
        ...state,
        isRequestingOtp: false,
        errorMessage: action.payload as string,
      }
    case otpActionTypes.RESEND_OTP_START:
      return {
        ...state,
        isResendingOtp: true,
        errorMessage: '',
      }
    case otpActionTypes.RESEND_OTP_SUCCESS:
      return {
        ...state,
        isResendingOtp: false,
      }
    case otpActionTypes.RESEND_OTP_ERROR:
      return {
        ...state,
        isResendingOtp: false,
        errorMessage: action.payload as string,
      }
    default:
      return state
  }
}
